/**
 * Cached DTO keys
 * @module cache
 */

const cache = {
  albums: {},
  alphanumeric: {},
  artists: {},
  bands: {},
  genres: {},
  grids: {},
  labels: {},
  page: {},
  regions: {},
  releases: {},
  years: {}
}

export default cache



// WEBPACK FOOTER //
// ./src/helpers/cache.js